import { Version } from '@treo/version/version';

const __TREO_VERSION__ = '2.0.0';
export const TREO_VERSION = new Version(__TREO_VERSION__).full;
